export const defaultVideos = [
  {
    id: '1',
    title: 'Trading Strategies',
    subtitle: 'Explained',
    description: 'Learn the core strategies used by top Wall Street traders to maximize profits and minimize risk in volatile markets.',
    category: 'Trending Now',
    tags: ['Strategy', 'Pro'],
    thumbnailUrl: 'https://images.unsplash.com/photo-1611974789855-9c2a0a7236a3?auto=format&fit=crop&q=80&w=600',
    duration: '13:00',
    accessLevel: 'free',
    videoUrl: 'https://www.youtube.com/watch?v=dQw4w9WgXcQ', // Using simple URL instead of iframe
    embedHtml: '', 
    status: 'published',
    isLive: false,
    progress: 75
  },
  {
    id: '2',
    title: 'Options Trading Mastery',
    subtitle: 'Advanced',
    description: 'Master the greeks and learn how to leverage options for exponential portfolio growth.',
    category: 'Continue Learning',
    tags: ['Options', 'Advanced'],
    thumbnailUrl: 'https://images.unsplash.com/photo-1590283603385-17ffb3a7f29f?auto=format&fit=crop&q=80&w=600',
    duration: '45:00',
    accessLevel: 'pro',
    videoUrl: 'https://www.youtube.com/watch?v=dQw4w9WgXcQ',
    embedHtml: '',
    status: 'published',
    isLive: false,
    progress: 30
  },
  {
    id: '3',
    title: 'Day Trading for Beginners',
    subtitle: 'Start Here',
    description: 'The ultimate guide to reading price action and executing day trades with precision.',
    category: 'Trending Now',
    tags: ['Beginner', 'Day Trading'],
    thumbnailUrl: 'https://images.unsplash.com/photo-1621416894569-0f39ed31d247?auto=format&fit=crop&q=80&w=600',
    duration: '16:00',
    accessLevel: 'pro',
    videoUrl: '',
    embedHtml: '',
    status: 'published',
    isLive: false,
    progress: 0
  },
  {
    id: '4',
    title: 'Technical Analysis Secrets',
    subtitle: 'Chart Mastery',
    description: 'Uncover hidden patterns in stock charts that predict major breakouts before they happen.',
    category: 'Trending Now',
    tags: ['Technical', 'Setup'],
    thumbnailUrl: 'https://images.unsplash.com/photo-1642543492481-44e81e391452?auto=format&fit=crop&q=80&w=600',
    duration: '13:00',
    accessLevel: 'pro',
    videoUrl: '',
    embedHtml: '',
    status: 'published',
    isLive: false,
    progress: 0
  },
  {
    id: '5',
    title: 'Swing Trading Tactics',
    subtitle: 'Multi-day holds',
    description: 'How to capture explosive multi-day moves while avoiding intraday noise.',
    category: 'Continue Learning',
    tags: ['Swing', 'Strategy'],
    thumbnailUrl: 'https://images.unsplash.com/photo-1535320903710-d9938a44917a?auto=format&fit=crop&q=80&w=600',
    duration: '19:00',
    accessLevel: 'pro',
    videoUrl: '',
    embedHtml: '',
    status: 'published',
    isLive: false,
    progress: 90
  },
  {
    id: '6',
    title: 'LIVE Trading Session',
    subtitle: '',
    description: 'Watch over our shoulder as we execute live trades in today\'s active market.',
    category: 'Live Sessions',
    tags: ['Live', 'Real-time'],
    thumbnailUrl: 'https://images.unsplash.com/photo-1518546305927-5a555bb7020d?auto=format&fit=crop&q=80&w=600',
    duration: '',
    accessLevel: 'pro',
    videoUrl: '',
    embedHtml: '',
    status: 'published',
    isLive: true,
    progress: 0
  },
  {
    id: '8',
    title: 'Introduction to RocketAlgo',
    subtitle: 'Getting Started',
    description: 'Your first steps into the RocketAlgo ecosystem. Learn the dashboard and tools.',
    category: 'Basics of RocketAlgo',
    tags: ['Beginner', 'Platform'],
    thumbnailUrl: 'https://images.unsplash.com/photo-1605792657660-596af9009e82?auto=format&fit=crop&q=80&w=600',
    duration: '15:20',
    accessLevel: 'free',
    videoUrl: '',
    embedHtml: '',
    status: 'published',
    isLive: false,
    progress: 0
  },
  {
    id: '9',
    title: 'Setting up your Charts',
    subtitle: 'Step by Step',
    description: 'Configure TradingView with our proprietary indicators for maximum clarity.',
    category: 'Basics of RocketAlgo',
    tags: ['Setup', 'Charting'],
    thumbnailUrl: 'https://images.unsplash.com/photo-1516245834210-c4c142718d21?auto=format&fit=crop&q=80&w=600',
    duration: '22:10',
    accessLevel: 'pro',
    videoUrl: '',
    embedHtml: '',
    status: 'published',
    isLive: false,
    progress: 0
  },
  {
    id: '10',
    title: 'Understanding Signals',
    subtitle: 'Buy & Sell Indicators',
    description: 'How to filter false signals and take only high-probability setups from our algo.',
    category: 'Basics of RocketAlgo',
    tags: ['Signals', 'Strategy'],
    thumbnailUrl: 'https://images.unsplash.com/photo-1639762681485-074b7f938ba0?auto=format&fit=crop&q=80&w=600',
    duration: '18:45',
    accessLevel: 'pro',
    videoUrl: '',
    embedHtml: '',
    status: 'published',
    isLive: false,
    progress: 0
  }
];

export const defaultLiveSettings = {
  title: 'Live Trading Session: Non-Farm Payrolls',
  description: 'Join us live as we trade the most volatile event of the month.',
  isLive: true,
  embedHtml: '<iframe src="https://www.youtube.com/embed/jfKfPfyJRdk" width="100%" height="100%" frameborder="0" allowfullscreen></iframe>',
  nextLiveAt: '2024-11-01T08:30',
};

export const defaultAds = {
  heroAdEnabled: true,
  headline: 'Master the Markets',
  subheadline: 'Join 10,000+ traders using AI-powered strategies to beat the market.',
  ctaText: 'Start Free Trial',
  ctaLink: 'https://pages.razorpay.com/rcktalgonewplan'
};